import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal } from "@/comn/hooks";
import { BASE, APIS, SF_CSTM_ORGZ_CD_SRCH, SG_CSTM_ORGZ_CD_LIST } from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const CustomsOrganizationCodeList = (props: any) => {
    const pgeUid = "cstmOrgzCdLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    const form = {
        cstmOrgzCdSrch: useForm({
            defaultSchema: SF_CSTM_ORGZ_CD_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        cstmOrgzCdList: useGrid({
            defaultSchema: SG_CSTM_ORGZ_CD_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCstmOrgzCdLst: useFetch({
            api: (page = grid.cstmOrgzCdList.page) => {
                return APIS.getCstmOrgzCdLst(form.cstmOrgzCdSrch.getValues(), page, grid.cstmOrgzCdList.size);
            },
            enabled: comnUtils.isEmpty(form.cstmOrgzCdSrch.errors) && form.cstmOrgzCdSrch.isSubmitted,
            key: [grid.cstmOrgzCdList.page, grid.cstmOrgzCdList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.cstmOrgzCdSrch.getValues(),
                    page: grid.cstmOrgzCdList.page,
                    size: grid.cstmOrgzCdList.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.cstmOrgzCdSrch.handleSubmit(
                () => {
                    grid.cstmOrgzCdList.setPage(0);
                    fetch.getCstmOrgzCdLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.cstmOrgzCdList.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.com.00086" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_CstmOrgzCdLst: {
            cell: {
                cstmOrgzCd: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({
                                    code: value,
                                    label: rowValues.cstmOrgzNm,
                                    cstmOrgzTpCd: rowValues.cstmOrgzTpCd,
                                });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        if (params?.cstmOrgzCd) {
            form.cstmOrgzCdSrch.setValue("cstmOrgzCd", params.cstmOrgzCd);
        }
        if (params?.cstmOrgzTpCd) {
            form.cstmOrgzCdSrch.setValue("cstmOrgzTpCd", params.cstmOrgzTpCd);
        }
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.cstmOrgzCdList.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_CSTM_ORGZ_CD_LST")} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmOrgzCdSrch.schema.cstmOrgzCd}></Group.Control>
                            <Group.Control {...form.cstmOrgzCdSrch.schema.cstmOrgzTpCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOrgzCdSrch.schema.cstmOrgzNm}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.cstmOrgzCdSrch.reset();
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.click_Btn_Srch();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.cstmOrgzCdList.grid}
                            data={fetch.getCstmOrgzCdLst.data?.cstmOrgzCdList}
                            render={render.grid_CstmOrgzCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
